import { lazy, Suspense } from "react";
import { Spinner } from "@jdoc/ui";
import { useWorkspace } from "@/state/workspaceStore";
import { AppHeader } from "@/components/AppHeader";
import { LandingPage } from "@/components/landing/LandingPage";

// Lazy-load the heavy per-format workspaces so PDF.js only loads for PDFs and
// Mammoth/docx/Tiptap only load for Word documents.
const PdfWorkspace = lazy(() =>
  import("@/features/pdf/PdfWorkspace").then((m) => ({
    default: m.PdfWorkspace,
  })),
);
const DocxWorkspace = lazy(() =>
  import("@/features/docx/DocxWorkspace").then((m) => ({
    default: m.DocxWorkspace,
  })),
);
const OdtWorkspace = lazy(() =>
  import("@/features/odt/OdtWorkspace").then((m) => ({
    default: m.OdtWorkspace,
  })),
);

function WorkspaceFallback() {
  return (
    <div className="flex h-full items-center justify-center gap-3 text-slate-500">
      <Spinner /> Loading tools…
    </div>
  );
}

export default function App() {
  const session = useWorkspace((s) => s.session);
  const original = useWorkspace((s) => s.original);

  return (
    <div className="flex h-full flex-col">
      <AppHeader />
      <main className="min-h-0 flex-1">
        <Suspense fallback={<WorkspaceFallback />}>
          {!session ? (
            <LandingPage />
          ) : session.kind === "pdf" && original ? (
            <PdfWorkspace original={original} />
          ) : session.kind === "docx" ? (
            <DocxWorkspace
              original={original ?? undefined}
              displayName={session.displayName}
            />
          ) : session.kind === "odt" && original ? (
            <OdtWorkspace original={original} displayName={session.displayName} />
          ) : (
            <LandingPage />
          )}
        </Suspense>
      </main>
    </div>
  );
}
